import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'searchbox-specs',
  templateUrl: './searchbox-specs.component.html',
  styleUrls: ['./searchbox-specs.component.sass']
})
export class SearchboxSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/searchbox/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
